import useReveal from '../hooks/useReveal';
import { PageMeta } from '../components/common';
import Hero from '../components/sections/Hero';
import SocialProof from '../components/sections/SocialProof';
import MarketCoverage from '../components/sections/MarketCoverage';
import IntelligencePipeline from '../components/sections/IntelligencePipeline';
import AITradeEngineSection from '../components/sections/AITradeEngineSection';
import StrategyEngineSection from '../components/sections/StrategyEngineSection';
import BacktestingSection from '../components/sections/BacktestingSection';
import TradeTerminalSection from '../components/sections/TradeTerminalSection';
import EndToEndWorkflow from '../components/sections/EndToEndWorkflow';
import TradeJournalSection from '../components/sections/TradeJournalSection';
import AIHumanControl from '../components/sections/AIHumanControl';
import SecuritySection from '../components/sections/SecuritySection';
import PricingPreview from '../components/sections/PricingPreview';
import KalkiCredits from '../components/sections/KalkiCredits';
import FAQSection from '../components/sections/FAQSection';
import FinalCTA from '../components/sections/FinalCTA';

export default function Home() {
  useReveal();
  return (
    <>
      <PageMeta title="Kalki AI — AI-Powered Market Intelligence & Trading" description="Kalki AI combines AI market intelligence, strategy analysis, backtesting and controlled trade execution in one advanced trading platform." />
      <Hero />
      <SocialProof />
      <MarketCoverage />
      <IntelligencePipeline />
      <AITradeEngineSection />
      <StrategyEngineSection />
      <BacktestingSection />
      <TradeTerminalSection />
      <EndToEndWorkflow />
      <TradeJournalSection />
      <AIHumanControl />
      <SecuritySection />
      <PricingPreview />
      <KalkiCredits />
      <FAQSection />
      <FinalCTA />
    </>
  );
}
